/**
 * The platform version this page was loaded with. The frontend container renders
 * it into env.js from the chart version at startup; null when env.js is not
 * rendered (local dev).
 */
export function loadedPlatformVersion() {
    const version = window.env?.APP_VERSION;
    return version && /^\d/.test(version) ? version : null;
}
